export const DEFAULT_CHECKOUT_ORIGIN =
  process.env.INFRAIO_CHECKOUT_ORIGIN || 'https://checkout.infraio.xyz';

export const EVENTS = {
  SUCCESS: 'INFRAIO_SUCCESS',
  CANCEL: 'INFRAIO_CANCEL',
} as const;

export const DOM_SELECTORS = {
  OVERLAY: 'data-infraio-overlay',
  LOADER: 'data-infraio-loader',
} as const;
